export default "__VITE_ASSET__D3aMq_W7__"